module.exports = __webpack_public_path__ + "480a2181cdaf2221f6cf98ac1500adeb.MP3";